import styled from 'styled-components'

export const StContainer = styled.div`
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
  max-width: ${({ theme }) => theme.UI.MaxWidthPx.Page};

  @media (min-width: ${({ theme }) => theme.UI.BreakpointPx.Tablet}) {
    padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space6};
  }
`
